import { render } from "./TilesColumn.vue?vue&type=template&id=976e23dc"
import script from "./TilesColumn.vue?vue&type=script&lang=js"
export * from "./TilesColumn.vue?vue&type=script&lang=js"

import "./TilesColumn.vue?vue&type=style&index=0&id=976e23dc&lang=scss"
script.render = render

export default script